<template>
  <main class="account-profile container-fluid mt-3 bg-white order-history-page">
    <div class="row h-100 no-gutters pt-5">
      <div class="col-12 mx-lg-auto">
        <div class="row no-gutters justify-content-center align-content-start align-content-lg-stretch h-100">
          <div class="col-12 col-xl-2 col-md-3 pt-lg-6 border-right ">
            <pc-side-nav />
          </div>

          <div class="col-12 col-lg mb-3 mb-lg-5 pt-6">
            <section id="order-section" class="mb-5 container-fluid table-responsive">
              <div class="row">
                <div class="col-md-12">
                  <div id="order-heading" class="d-flex">
                    <p class="font-weight-normal text-uppercase">
                      {{ $resourceString["account.MyOrders.Label.SampleOrderHistory"] }}
                    </p>
                  </div>
                  <p>
                    {{ $resourceString["account.Orders.Contactus"] }}
                    <a :href="`mailto:${$resourceString['account.Orders.Info.Patcraft.Email']}`">{{ $resourceString["account.Orders.Info.Patcraft.Email"] }}</a> 
                    {{ $resourceString["account.Orders.Info.Call"] }}
                    +<a :href="`tel:${$resourceString['account.Orders.Info.Patcraft.Call']}`">{{ $resourceString["account.Orders.Info.Patcraft.Call"] }}</a>
                  </p>
                </div>
              </div>
              <hr/>
              <div class="row mt-4 mb-4" v-if="dataset.accountManagerName && dataset.accountManagerName != ''">
                <div class="col-md-12">
                  <div class="d-flex">
                    <p class="font-weight-normal text-uppercase">
                      {{ $resourceString["account.MyOrders.Label.MyPatcraftAccountManager"] }}
                    </p>
                  </div>
                  <p>
                    {{ dataset.accountManagerName }} <span v-if="dataset.accountManagerCity"><br/>{{ dataset.accountManagerCity }}</span><br/><a v-if="dataset.accountManagerEmail" :href="`mailto:${dataset.accountManagerEmail}`">{{ dataset.accountManagerEmail }}</a>
                  </p>
                </div>
              </div>

              <table class="table table-borderless mb-4">
                <thead>
                  <tr class="border-bottom">
                    <th class="border-bottom">{{ $resourceString["account.Orders.OrderData.Label"] }}</th>
                    <th class="border-bottom">{{ $resourceString["account.Orders.Order.Label"] }}</th>
                    <th class="border-bottom">{{ $resourceString["account.MyOrders.Label.NumberOfSample"] }}</th>
                    <th class="border-bottom">{{ $resourceString["account.Orders.TrackingInfo.Label"] }}</th>
                    <th class="border-bottom">{{ $resourceString["account.Orders.Status.Label"] }}</th>
                    <th class="border-bottom"></th>
                  </tr>
                  <tr>
                    <td colspan="6"></td>
                  </tr>
                </thead>
                <tbody class="border">
                  <tr v-if="orderhistory.length == 0">
                    <td colspan="6">
                      {{ $resourceString["account.Orders.NoOrder.Label"] }}
                    </td>
                  </tr>
                  <template v-for="(order, index) in currentOrders">
                    <tr class="bg-light">
                      <td>
                        {{
                          order.order && order.order.cart && order.order.cart.created
                            ? new Date(order.order.cart.created).toLocaleDateString("en-US", {
                                hour: "numeric",
                                minute: "numeric",
                                second: "numeric"
                              })
                            : (order.orderInfo && order.orderInfo.orderSubmitted ? order.orderInfo.orderSubmitted : "")
                        }}
                      </td>

                      <td>{{ order.orderID }}</td>
                      <td>{{ order.order && order.order.cart && order.order.cart.items ? order.order.cart.items.length : 0 }}</td>
                      <td>{{ order.trackingInfo || "" }}</td>
                      <td>
                        <span v-if="!order.order || order.errorMessage">
                          {{ order.errorMessage || "" }}
                        </span>
                        <span v-else>{{ order.order.orderStatus.status }}</span>
                      </td>
                      <td @click="toggleOrder(index)" class="cursor-pointer">
                        <span :class="`png-icon png-icon-icons-glyph--k-chevron-${expandedOrder === index ? 'up' : 'down'}`"></span>
                      </td>
                    </tr>
                    <tr class="bg-light" v-show="expandedOrder === index">
                      <td colspan="6">
                        <div class="border-bottom"></div>
                      </td>
                    </tr>
                    <tr class="bg-light" v-show="expandedOrder === index">
                      <td colspan="6" class="mt-2">
                        <div class="row">
                          <div class="col-12 order-container">
                            <p><strong>{{ $resourceString["account.MyOrders.Label.OrderType"] }}:</strong> {{ order.order.orderType || "" }}</p>
                            <p><strong>{{ $resourceString["account.MyOrders.Label.Project"] }}:</strong> {{ order.order.extensionData && order.order.extensionData.projectName || "" }}</p>
                            <p><strong>{{ $resourceString["account.MyOrders.Label.ShippedTo"] }}:</strong> {{ `${order.order.shippingAddress && order.order.shippingAddress.addressLine1 ? order.order.shippingAddress.addressLine1 + "," : ""} ${order.order.shippingAddress && order.order.shippingAddress.addressLine2 ? order.order.shippingAddress.addressLine2 + "," : ""} ${order.order.shippingAddress && order.order.shippingAddress.locality ? order.order.shippingAddress.locality + "," : ""} ${order.order.shippingAddress && order.order.shippingAddress.administrativeArea ? order.order.shippingAddress.administrativeArea + "," : ""} ${order.order.shippingAddress && order.order.shippingAddress.postalCode ? order.order.shippingAddress.postalCode + "," : ""}` }}</p>
                          </div>
                          <!-- <div class="col-3 text-center">
                            <button class="btn btn-dark">RETURN SAMPLES</button>
                          </div> -->
                        </div>

                        <div class="border-bottom"></div>
                        
                        <div class="row p-3 mb-3" v-for="(orderCart, cartIndex) in order.order && order.order.cart && order.order.cart.items ? order.order.cart.items : []" :key="cartIndex">
                          <div class="col-2">
                            <img v-if="orderCart.styleName === 'idea book'" :src="orderCart.image || 'https://img.shawinc.com/s7/is/image/ShawIndustriesCommercial/SZ009_00001_MAIN?wid=130'" class="product-img w-100" :alt="orderCart.styleName + orderCart.sellingStyleNumber">
                            <a v-else class="cart-item-model-no" target="_blank" :href="$helpers.getProductDetailUrl(
                                slugify(orderCart.styleName),
                                orderCart.sellingStyleNumber,
                                orderCart.sellingColorNumber
                              )
                            ">
                              <img :src="orderCart.image || 'https://img.shawinc.com/s7/is/image/ShawIndustriesCommercial/SZ009_00001_MAIN?wid=130'" class="product-img w-100" :alt="orderCart.styleName + orderCart.sellingStyleNumber">
                            </a>
                          </div>
                          <div class="col-4">
                            <p class="text-capitalize"><strong>{{ $resourceString["account.MyOrders.Label.Style"] }}:</strong> 
                              <a :href="$helpers.getProductDetailUrl(
                                  slugify(orderCart.styleName),
                                  orderCart.sellingStyleNumber,
                                  orderCart.sellingColorNumber
                                )
                              " 
                              v-if="orderCart.styleName != 'idea book'"
                              class="text-danger">
                                {{ orderCart.styleName }} {{ orderCart.sellingStyleNumber }}
                              </a>
                              <span class="text-dark" v-else>
                                {{ orderCart.styleName }} {{ orderCart.sellingStyleNumber }}
                              </span>
                            </p>
                            <p class="text-capitalize"><strong>{{ $resourceString["account.MyOrders.Label.Color"] }}:</strong> {{ orderCart.sellingColorNumber }}</p>
                            <p class="text-capitalize" v-if="orderCart.collectionName"><strong>{{ $resourceString["account.MyOrders.Label.Collection"] }}:</strong> {{ orderCart.collectionName }}</p>
                            <p><strong>{{ $resourceString["account.MyOrders.Label.Quantity"] }}:</strong> {{ orderCart.quantity || "" }}</p>
                          </div>
                          <div class="col-4">
                            <p v-if="orderCart.productType" class="text-capitalize"><strong>{{ $resourceString["account.MyOrders.Label.Product"] }}:</strong> {{ orderCart.productType }}</p>
                            <p class="text-capitalize"><strong>{{ $resourceString["account.MyOrders.Label.Category"] }}:</strong> {{ orderCart.styleName === "idea book" ? "Sundry" : orderCart.productCategory || "" }}</p>
                            <p v-if="orderCart.styleName != 'idea book'"><strong>{{ $resourceString["account.MyOrders.Label.SampleSize"] }}:</strong> {{ orderCart.sampleSize || "" }}</p>
                          </div>
                          <div class="col-2 d-flex align-items-center justify-content-center">
                            <a
                              class="text-uppercase cursor-pointer"
                              @click="addItemToCart(orderCart.sellingStyleNumber, orderCart.sellingColorNumber, orderCart.vehicleId, order.order.orderType)"
                              v-if="(orderCart.vehicleId) === 0 || OrderSampleEnabled || samplesAvailable === 0"
                            >
                              {{ $resourceString["account.MyOrders.Label.OrderAgain"] }}
                            </a>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr><td colspan="6"></td></tr>
                  </template>
                </tbody>
              </table>

              <div class="row mb-4" v-if="orderhistory.length > 0">
                <div class="col-12">
                  <div class="pagination justify-content-end">
                    <button
                        class="btn btn-white bg-transparent mr-2 text-lowercase"
                    >
                      {{ currentPage }} of {{ totalPages }}
                    </button>

                    <!-- Previous button -->
                    <button class="btn btn-dark mr-2" :disabled="currentPage === 1" @click="previousPage"><</button> 
            
                    <!-- Next button -->
                    <button class="btn btn-dark mr-2" :disabled="currentPage === totalPages" @click="nextPage">></button>
                  </div>
                </div>
              </div>

              <p v-if="orderhistory.length > 0">
                <span v-html="$resourceString['printLabel.Account.LinkText']"></span>
                {{ $resourceString["printLabel.Account.LinkDescription"] }}
              </p>
              <p>
                {{ $resourceString["return.Account.Description"] }}
                <a href="mailto:samples@patcraft.com">{{ $resourceString["account.Orders.Info.Patcraft.Samples.Call"] }}</a>
                {{ $resourceString["return.Account.DescriptionEnd"] }}
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PcSideNav from "../my-trays-page/pc-side-nav.vue";

export default {
  props: ["orderhistory", "dataset"],
  data() {
    return {
      expandedOrder: -1,
      currentPage: 1,
      itemsPerPage: 10
    };
  },
  computed: {
    ...mapGetters({
      OrderSampleEnabled: "productDetail/getisOrderSampleEnabled",
      samplesAvailable: "productDetail/samplesAvailable"
    }),
    totalPages() {
      return Math.ceil(this.orderhistory.length / this.itemsPerPage);
    },
    currentOrders() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.orderhistory.slice(start, end);
    }
  },
  methods: {
    ...mapActions({
      addToCart: "basketPage/addToCart",
    }),
    toggleOrder(index) {
      this.expandedOrder = this.expandedOrder === index ? -1 : index;
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    },
    slugify(string) {
      return string && string.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+|-+$/g, '') || "";
    },
    addItemToCart(sellingStyleNumber, colorNumber, vehicleId, orderType) {
      let data = {
        sellingStyleNumber,
        colorNumber,
        vehicleId,
        quantity: 1,
        saveForLater: false,
        isTrayItem: (orderType && orderType.toLowerCase()) == (this.$resourceString["orderType.Tray"] || "").toLowerCase()
      };
      this.addToCart(data);
    },
  },
  components: {
    PcSideNav
  }
};
</script>
<style>
  .order-history-page table .border-bottom{
    border-bottom: 2px solid #a4a4a4 !important;
  }
</style>